import React from "react";
import {validationStyle} from "./style";

export const validateVirtualSlipDataCreate = (values, {translate}) => {
  const errors = {};
  if (!values.type || values.type.trim() === "") {
    errors.type = translate(
      "resources.virtualSlips.validation.requiredBetType"
    );
  }

  if (!values.store_name || values.store_name.trim() === "") {
    errors.store_name = translate(
      "resources.virtualSlips.validation.requiredStoreName"
    );
  }

  if (!values.expert || values.expert.trim() === "") {
    errors.expert = translate(
      "resources.virtualSlips.validation.requiredExpert"
    );
  }

  if (!values.start_date) {
    errors.start_date = translate(
      "resources.virtualSlips.validation.requiredStartDate"
    );
  }

  if (!values.bet_pairs) {
    errors.bet_pairs = translate(
      "resources.virtualSlips.validation.requiredAtLestOne"
    );
  }

  if (
    !values.shares ||
    values.shares.trim() === "" ||
    !values.shares.match(/^[0-9]+[.,]?([0-9]+)?$/)
  ) {
    errors.shares = translate(
      "resources.virtualSlips.validation.requiredShareNumber"
    );
  }

  if (
    !values.share_cost ||
    values.share_cost.trim() === "" ||
    !values.share_cost.match(/^[0-9]+[.,]?([0-9]+)?$/)
  ) {
    errors.share_cost = translate(
      "resources.virtualSlips.validation.requiredShareCost"
    );
  }

  if (
    !values.total_cost ||
    values.total_cost.trim() === "" ||
    !values.total_cost.match(/^[0-9]+[.,]?([0-9]+)?$/)
  ) {
    errors.total_cost = translate(
      "resources.virtualSlips.validation.requiredTotalCost"
    );
  }

  if (
    !values.agent_charge ||
    values.agent_charge.trim() === "" ||
    !values.agent_charge.match(/^[0-9]+[.,]?([0-9]+)?$/)
  ) {
    errors.agent_charge = translate(
      "resources.virtualSlips.validation.requiredAgentCharge"
    );
  }

  if (!values.closing_time) {
    errors.closing_time = translate(
      "resources.virtualSlips.validation.requiredClosingTime"
    );
  }

  return errors;
};

export const validateVirtualSlipDataEdit = (values, {translate}) => {
  const errors = {};
  if (!values.type || values.type.trim() === "") {
    errors.type = translate(
      "resources.virtualSlips.validation.requiredBetType"
    );
  }

  if (!values.store_name || values.store_name.trim() === "") {
    errors.store_name = translate(
      "resources.virtualSlips.validation.requiredStoreName"
    );
  }

  if (!values.expert || values.expert.trim() === "") {
    errors.expert = translate(
      "resources.virtualSlips.validation.requiredExpert"
    );
  }

  if (!values.start_date) {
    errors.start_date = translate(
      "resources.virtualSlips.validation.requiredStartDate"
    );
  }

  if (!values.bet_pairs) {
    errors.bet_pairs = translate(
      "resources.virtualSlips.validation.requiredAtLestOne"
    );
  }

  if (
    !values.shares ||
    values.shares.trim() === "" ||
    !values.shares.match(/^[0-9]+[.,]?([0-9]+)?$/)
  ) {
    errors.shares = translate(
      "resources.virtualSlips.validation.requiredShareNumber"
    );
  }

  if (
    !values.share_cost ||
    values.share_cost.trim() === "" ||
    !values.share_cost.match(/^[0-9]+[.,]?([0-9]+)?$/)
  ) {
    errors.share_cost = translate(
      "resources.virtualSlips.validation.requiredShareCost"
    );
  }

  if (
    !values.total_cost ||
    values.total_cost.trim() === "" ||
    !values.total_cost.match(/^[0-9]+[.,]?([0-9]+)?$/)
  ) {
    errors.total_cost = translate(
      "resources.virtualSlips.validation.requiredTotalCost"
    );
  }

  if (
    !values.agent_charge ||
    values.agent_charge.trim() === "" ||
    !values.agent_charge.match(/^[0-9]+[.,]?([0-9]+)?$/)
  ) {
    errors.agent_charge = translate(
      "resources.virtualSlips.validation.requiredAgentCharge"
    );
  }

  if (!values.closing_time) {
    errors.closing_time = translate(
      "resources.virtualSlips.validation.requiredClosingTime"
    );
  }

  return errors;
};

export const required = (value, allValues, props) =>
  (!value || value.trim() === "") && (
    <div style={validationStyle.required}>
      {props.translate("resources.virtualSlips.validation.requiredField")}
    </div>
  );

export const validateBoost = (value, allValues, props) =>
  (!value || value.trim() === "") && (
    <div style={validationStyle.validateBoost}>
      {props.translate("resources.virtualSlips.validation.requiredField")}
    </div>
  );

export const validateBoostIdentificationNumber = (value, allValues, props) =>
  (!value ||
    value.trim() === "" ||
    value.length !== 3 ||
    !value.match(/^[0-9][0-9][0-9]$/)) && (
    <div style={validationStyle.validateBoost}>
      {props.translate("resources.virtualSlips.validation.requiredBINLength")}
    </div>
  );

export const validateStoreName = (value, allValues, props) =>
  (!value || value.trim() === "") &&
  props.translate("resources.virtualSlips.validation.requiredStoreName");

export const validateOutcomeItems = (value, allValues, props) =>
  (!value || value.trim() === "") && (
    <div style={validationStyle.validateOutcome}>
      {props.translate("resources.virtualSlips.validation.requiredField")}
    </div>
  );



// WEBPACK FOOTER //
// ./src/containers/CRM/VirtualSlips/validations.js